// The Data Explorer guide (55_DataExplorer.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Your reports',
  tabsB: 'My reports are the ones you built, Shared with me are the ones other people gave you, and All lists every report if you build reports. The number on each tab is how many it holds.',
  searchT: 'Find a report',
  searchB: 'Type a report name, its owner or its dataset to cut the list down.',
  newT: 'Start a new report',
  newB: 'New report opens an empty report to build with your own visuals. It is there only if you are allowed to build reports.',
  listT: 'The list',
  listB: 'One row per report with its dataset, owner, who it is shared with, number of pages and last update. Click a name to open the report.',
  actionsT: 'What you can do with a report',
  actionsB: 'Open it, Copy link to send it to someone, and, for your own reports, Share, Rename or Delete. A report shared with you can only be opened or linked.',
};
const ko = {
  tabsT: '내 보고서 목록',
  tabsB: '내 보고서는 직접 만든 것, 나와 공유됨은 다른 사람이 공유해 준 것이며, 보고서를 만들 수 있는 경우 전체에서 모든 보고서를 볼 수 있습니다. 탭의 숫자는 건수입니다.',
  searchT: '보고서 찾기',
  searchB: '보고서 이름, 소유자 또는 데이터셋을 입력하면 목록이 좁혀집니다.',
  newT: '새 보고서 시작',
  newB: '새 보고서는 빈 보고서를 열어 직접 시각화를 만들 수 있게 합니다. 보고서 작성 권한이 있을 때만 보입니다.',
  listT: '목록',
  listB: '보고서마다 한 행으로 데이터셋, 소유자, 공유 대상, 페이지 수, 최근 수정이 표시됩니다. 이름을 클릭하면 보고서가 열립니다.',
  actionsT: '보고서에서 할 수 있는 작업',
  actionsB: '열기, 다른 사람에게 보낼 링크 복사가 있고, 내 보고서에는 공유, 이름 변경, 삭제가 더 있습니다. 공유받은 보고서는 열기와 링크 복사만 됩니다.',
};
const vi = {
  tabsT: 'Báo cáo của bạn',
  tabsB: 'My reports là báo cáo bạn tự tạo, Shared with me là báo cáo người khác chia sẻ cho bạn, còn All liệt kê mọi báo cáo nếu bạn có quyền tạo báo cáo. Số trên mỗi tab là số báo cáo trong đó.',
  searchT: 'Tìm báo cáo',
  searchB: 'Gõ tên báo cáo, người sở hữu hoặc dataset để thu hẹp danh sách.',
  newT: 'Tạo báo cáo mới',
  newB: 'Nút New report mở một báo cáo trống để bạn tự dựng các biểu đồ. Nút này chỉ có khi bạn được phép tạo báo cáo.',
  listT: 'Danh sách',
  listB: 'Mỗi dòng là một báo cáo, kèm dataset, người sở hữu, người được chia sẻ, số trang và lần cập nhật gần nhất. Bấm vào tên để mở báo cáo.',
  actionsT: 'Việc làm được với một báo cáo',
  actionsB: 'Mở báo cáo, chép link để gửi người khác, và với báo cáo của chính bạn thì có thêm Chia sẻ, Đổi tên, Xóa. Báo cáo được chia sẻ cho bạn chỉ mở hoặc lấy link được.',
};
const zh = {
  tabsT: '您的报表',
  tabsB: '“我的报表”是您自己创建的，“与我共享”是他人分享给您的，如果您可以创建报表，“全部”会列出所有报表。每个标签上的数字是其中的报表数。',
  searchT: '查找报表',
  searchB: '输入报表名称、所有者或数据集即可缩小列表范围。',
  newT: '新建报表',
  newB: '“新建报表”会打开一个空白报表，让您用自己的图表来搭建。只有被允许创建报表的人才能看到。',
  listT: '列表',
  listB: '每个报表一行，显示数据集、所有者、共享对象、页数和最近更新。点击名称即可打开报表。',
  actionsT: '对报表可以做什么',
  actionsB: '可以打开、复制链接发给他人；对自己的报表还可以共享、重命名或删除。他人共享给您的报表只能打开或复制链接。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Vos rapports",
  "tabsB": "Mes rapports sont ceux que vous avez créés, Partagés avec moi ceux que d'autres vous ont partagés, et « Tous » liste tous les rapports si vous créez des rapports. Le nombre sur chaque onglet indique combien il en contient.",
  "searchT": "Trouver un rapport",
  "searchB": "Saisissez le nom d'un rapport, son propriétaire ou son jeu de données pour réduire la liste.",
  "newT": "Démarrer un nouveau rapport",
  "newB": "Nouveau rapport ouvre un rapport vide à construire avec vos propres visuels. Il n'est présent que si vous avez le droit de créer des rapports.",
  "listT": "La liste",
  "listB": "Une ligne par rapport avec son jeu de données, son propriétaire, les personnes avec qui il est partagé, son nombre de pages et sa dernière mise à jour. Cliquez sur un nom pour ouvrir le rapport.",
  "actionsT": "Ce que vous pouvez faire d'un rapport",
  "actionsB": "Ouvrir, Copier le lien pour l'envoyer à quelqu'un, et, pour vos propres rapports, Partager, Renommer ou Supprimer. Un rapport partagé avec vous ne peut qu'être ouvert ou lié."
};
const ja = {
  "tabsT": "あなたのレポート",
  "tabsB": "「自分のレポート」は自分で作成したもの、「共有されたレポート」は他の人から共有されたものです。レポートを作成する権限がある場合は、「すべて」ですべてのレポートを一覧表示します。各タブの数字は件数です。",
  "searchT": "レポートを探す",
  "searchB": "レポート名、オーナー、データセットを入力してリストを絞り込みます。",
  "newT": "新しいレポートを作成",
  "newB": "「新規レポート」で空のレポートが開き、ご自身のビジュアルで作成できます。レポートの作成権限がある場合のみ表示されます。",
  "listT": "リスト",
  "listB": "レポートごとに1行で、データセット、オーナー、共有先、ページ数、最終更新を表示します。名前をクリックするとレポートが開きます。",
  "actionsT": "レポートでできること",
  "actionsB": "開く、リンクをコピー（他の人に送る場合）、そして自分のレポートでは共有、名前の変更、削除ができます。共有されたレポートは、開くかリンクをコピーすることしかできません。"
};

const dictionary = { ns: 'tourExplorer', en, ko, vi, zh, fr, ja };
export default dictionary;
